import axios from "axios";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function addScript(payload) {
    const result = await axios.post(apiUrl + "/admin/profile/addscript",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function removeScript(payload) {
    const result = await axios.post(apiUrl + "/admin/profile/removescript",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const ProfileService = {
    addScript,
    removeScript
}